import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';

type PickerMode = 'date' | 'week' | 'month' | 'quarter' | 'year';

@Component({
  selector: 'om-date-range',
  templateUrl: './om-date-range.component.html',
  styleUrls: []
})
@UntilDestroy()
export class OmDateRangeComponent implements OnInit {
  @Input() label: string;
  @Input() control: FormControl;
  @Input() deletable: boolean = true;
  @Input() required: boolean = false;
  @Input() icon: string;
  @Input() fromLabel: string;
  @Input() toLabel: string;
  @Input() mode: PickerMode = 'date';
  @Input() allowClear: boolean = true;

  @Output() close: EventEmitter<Event> = new EventEmitter<Event>();

  _placeholder: string[] = [];

  constructor(private _translateService: TranslateService, private _fb: FormBuilder) {}

  ngOnInit(): void {
    this.control = this.control ?? new FormControl([new Date(), new Date()], [Validators.required]);

    this.fromLabel = this?.fromLabel || this._translateService.instant('SETTINGS.CALENDARS_SETTINGS.FROM_DAY');
    this.toLabel = this?.toLabel || this._translateService.instant('SETTINGS.CALENDARS_SETTINGS.TO_DAY');

    this._placeholder = [this.fromLabel, this.toLabel];

    this.control.valueChanges.pipe(untilDestroyed(this)).subscribe((_) => this.control.markAllAsTouched());
  }

  _emitClose(event: Event): void {
    this.close.emit(event);
  }
}
